import React from 'react';
import { useHistory } from 'react-router-dom';
import { isDevelopment } from '../../constants/app';
import {
  redirectToLogin,
  setRedirectPathInLocalStorage,
} from '../../helpers/browser';

const RedirectToLogin: React.FC = () => {
  const history = useHistory();
  React.useEffect(() => {
    setRedirectPathInLocalStorage(
      history.location.pathname,
      history.location.hash,
    );

    if (!isDevelopment) {
      redirectToLogin();
    }
  });

  if (!isDevelopment) return null;

  return <div>I'm the development redirect page </div>;
};

export default RedirectToLogin;
